import React, {  useEffect, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { Button, Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Input, FormControl, FormLabel } from "@chakra-ui/react"
import axios from 'axios';
import { Auth } from "./Auth";
import DatePicker from "react-datepicker";
import { Text } from "@chakra-ui/react";
export default function UpdateDeliveryDate({orderData, tenureData}) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const finalRef = React.useRef(null)
  const [deliveryDate, setDeliveryDate] = useState(Date.parse(orderData.fulFilledDate) || new Date());
  const [saving, setSaving] = useState(false);
  const [rlNumber, setRlNumber] = useState(orderData.rlNumber || '');
  const [isRlNumbersPresent, setIsRlNumbersPresent] = useState(false);

  const update = async () => {
    setSaving(true);
    const _deliveryDate  = new Date(deliveryDate).toISOString().split('T')[0];
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${orderData.id}/update-delivery-date`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data: {
        deliveryDate: _deliveryDate,
        tenureId: tenureData.id
      }
    };
    
    axios.request(config)
      .then(function (response) {
        console.log(response.data);
        setSaving(false);
        onClose();
        window.location.reload();
        onClose();
      })
      .catch(function (error) {
        console.error(error);
        setSaving(false);
        onClose();
        // window.location.reload();
      });
  }

  const handleDateChange = (date) => {
    setDeliveryDate(date);
  }


  useEffect(() => {
    setIsRlNumbersPresent(orderData.OrderItem.some(item => item.rlNumber));
  }, [orderData]);

  return (
    <>
      <Button colorScheme='green'  onClick={onOpen}>
        Mark Delivered
      </Button>
      <Modal finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm delivery date</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <FormControl>
                <FormLabel>Delivery Date</FormLabel>
                <DatePicker selected={deliveryDate}
                  onChange={(date) => handleDateChange(date)}
                  format="yyyy-MM-dd"
                  className="form-control"
                />
              </FormControl>
              
              {!isRlNumbersPresent && (
                <Text color="red" fontSize="sm" mt={2}> {"Some Order Items do not have RL Number"} </Text>
              )}
              
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button variant='ghost' 
              disabled={saving}
              onClick={onClose}>Cancel</Button>
            <Button colorScheme='green' mr={3} onClick={update}
              isLoading={saving}
              loadingText="Saving"
            >
              Mark Delivered
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}